import { render, staticRenderFns } from "./checkPutOnShelvesLabel.vue?vue&type=template&id=2bce9f5e&scoped=true&"
import script from "./checkPutOnShelvesLabel.vue?vue&type=script&lang=js&"
export * from "./checkPutOnShelvesLabel.vue?vue&type=script&lang=js&"
import style0 from "./checkPutOnShelvesLabel.vue?vue&type=style&index=0&id=2bce9f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce9f5e",
  null
  
)

export default component.exports